import { render, staticRenderFns } from "./AiSearch.vue?vue&type=template&id=ca4d8930&scoped=true"
import script from "./AiSearch.vue?vue&type=script&lang=js"
export * from "./AiSearch.vue?vue&type=script&lang=js"
import style0 from "./AiSearch.vue?vue&type=style&index=0&id=ca4d8930&prod&lang=css"
import style1 from "./AiSearch.vue?vue&type=style&index=1&id=ca4d8930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4d8930",
  null
  
)

export default component.exports